export function fixPrice(price: any): string {
  let res = Number.parseFloat(price).toFixed(2)
  if(isNaN(res))return ""
  return res
}
